import { get, filter } from "lodash-es";
window._ = {
  get,
  filter,
};

require("./mobile/react-native-link");
require("./mobile/push-registration");

require("./axios");

require("./alpine/alpine");
require("./alpine/alpine-search");
require("./alpine/alpinejs-ui-3_13_8-beta.min.js");

require("../../vendor/wire-elements/pro/resources/js/overlay-component.js");

require("./toast");

require("./hybrid-forms");

require('./helpers')

require('./tricks/stuck')
require('./tricks/show-behind')
require('./tricks/fit-header-text')
require('./tricks/vertical-line-from-to')

import Choices from "choices.js";
window.Choices = Choices;

import flatpickr from "flatpickr";

const Dutch = require("flatpickr/dist/l10n/nl.js").default.nl;
flatpickr.localize(Dutch);
flatpickr.l10ns.default.firstDayOfWeek = 1; // Monday
require("flatpickr/dist/themes/airbnb.css");

import { setupWorkbox } from "./workbox";
setupWorkbox();

// Enable alpine listner
document.addEventListener('alpine:init', () => {
  Alpine.magic('clipboard', () => {
    let clipboard = navigator.clipboard
    if (!clipboard) {
      console.log('clipboard is only supported in secure (https) contexts')
      return () => { }
    }

    return subject => navigator.clipboard.writeText(subject)
  })

  Alpine.magic('toast', () => {
    return params => toast(params.message, params.type, { 'position': 'right' })
  })
})

// Screen transition
window.addEventListener("beforeunload", () => {
  // create a div
  const div = document.createElement("div");
  // add class to div
  div.classList.add("horizontal-loading-indicator");
  div.classList.add("fixed");
  div.classList.add("top-0");
  div.classList.add("left-0");
  div.classList.add("z-50");

  // append div to body
  document.body.appendChild(div);
});
